module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"version":"version","code":"codename"},"ua":{"version":"версія","code":"внутрішнє ім\u0027я"},"ru":{"version":"версия","code":"внутреннее имя"}}')
  delete Component.options._Ctor
}
